import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Select } from 'antd';
import DrawerModal from '../../components/shared/DrawerModal';
import { getIsVisibleModal, closeModal } from '../../redux/store/ui/common';
import styles from './UpdateAreaFleetStyleModal.styles';
import { useIntl } from 'react-intl';
import {
  selectSelectedArea,
  updateArea,
} from '../../redux/store/appData/areas';
import { zIndex } from '../../theme/theme';
import { selectAdminBrands } from '../../redux/store/userData/user';

const { Option } = Select;

const UpdateAreaFleetStyleModal = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const brands = useSelector(selectAdminBrands);
  const fleetStyles = brands?.[0]?.fleetStyles;
  const visibleModal = useSelector(
    getIsVisibleModal('updateAreaFleetStyleModal')
  );
  const selectedArea = useSelector(selectSelectedArea);

  const [fleetStyle, setFleetStyle] = useState(selectedArea?.fleetStyle) as any;

  const handleOnSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    dispatch(updateArea(selectedArea?.id, { fleetStyle: fleetStyle }));
    dispatch(closeModal('updateAreaFleetStyleModal'));
  };

  const handleOnCancel = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    dispatch(closeModal('updateAreaFleetStyleModal'));
  };

  const handleUpdateFleetStyle = (
    value: React.SetStateAction<string | undefined>
  ) => {
    setFleetStyle(value);
  };

  useEffect(() => {
    if (visibleModal) {
      setFleetStyle(selectedArea?.fleetStyle ?? null);
    }
  }, [visibleModal, selectedArea]);

  return (
    <>
      <DrawerModal
        visible={visibleModal}
        onClose={() => {
          dispatch(closeModal('updateAreaFleetStyleModal'));
        }}
      >
        <div className="update-area-fleetStyle-modal">
          <div className="update-area-fleetStyle-wrapper">
            <p className="label">
              {intl.formatMessage({
                id: `fleetadmin.area.fleetStyle`,
              })}
            </p>
            <div className="fleetStyle-selector-wrapper">
              <Select
                defaultValue={fleetStyle}
                dropdownStyle={{ zIndex: zIndex.dropDown }}
                value={fleetStyle}
                style={{ width: '100%' }}
                loading={false}
                onChange={handleUpdateFleetStyle}
              >
                <Option value={null}>
                  <span>Not assigned</span>
                </Option>
                {fleetStyles?.map((fleet) => (
                  <Option key={`fleet-option-${fleet}`} value={fleet}>
                    {fleet}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
          <Button
            className="submit-button"
            onClick={handleOnSubmit}
            disabled={!fleetStyle}
          >
            {intl.formatMessage({
              id: `submit`,
            })}
          </Button>
          <Button className="cancel-button" onClick={handleOnCancel}>
            {intl.formatMessage({
              id: `cancel`,
            })}
          </Button>
        </div>
      </DrawerModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default UpdateAreaFleetStyleModal;
